// extracted by mini-css-extract-plugin
module.exports = {"root":"TextArea_root__14eJ8","textarea":"TextArea_textarea__2_lqN"};